<template>
  <section class="product-top container-full" v-if="isOpen">
    <div class="background">
      <div class="container">
        <div class="row">
          <div class="col-xs col-md-6">
            <HeightSelector :options="options" @input="selectOption" />
          </div>

          <div class="col-xs col-md-6 col-lg-5 hidden-xs">
            <div class="product-top-right">
              <div class="product-top-about">
                <div class="product-top-about-head head-sm">
                  Über diesen Zaun
                </div>
                <div
                  class="product-top-about-description"
                  v-html="category.pulldowntext"
                  v-if="category"
                />
                <a
                  @click="jumpToProduct"
                  class="btn btn-secondary"
                >Jetzt entdecken</a>
              </div>
              <div class="product-top-right-bg">
                <img
                  v-if="image"
                  v-lazy="image"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getAvailableFiltersByProduct, getSelectedFiltersByProduct } from '@vue-storefront/core/modules/catalog/helpers/filters'
import HeightSelector from '../../Custom/HeightSelector'

export default {
  components: {
    HeightSelector
  },
  data () {
    return {
      isOpen: true
    }
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    image: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    category () {
      if (this.product.category && typeof this.product.category[0] === 'object') {
        const category = this.product.category[0];
        return this.$store.state['category-next'].menuCategories.find(c => {
          return c.id === category.category_id
        })
      }
      return {};
    },
    getAvailableFilters () {
      return getAvailableFiltersByProduct(this.product)
    },
    getRange () {
      return Array(20).fill(400).map((x, y) => x - y * 20);
    },
    getFirstOption () {
      return this.product.configurable_options[0];
    },
    options () {
      const option = this.getFirstOption;
      return this.getAvailableFilters[option.attribute_code].slice(0).reverse().map((o) => {
        return {
          label: option.label + ' ' + o.label,
          value: o
        }
      })
    }
  },
  watch: {
    /* product (newVal, oldVal) {
      if (newVal.parentId !== oldVal.parentId) {
        const minHeight = this.getRichOptions.filter((option) => option.type === 'torhhe').reverse()[0]
        if (typeof minHeight === 'object') {
          this.$emit('input', minHeight)
          this.isOpen = true;
        }
      }
    } */
  },
  methods: {
    selectOption (option) {
      this.closeHeightSelector()
      this.$emit('input', option)
    },
    openHeightSelector () {
      this.isOpen = true
      window.scrollTo('.container-full', 0, { offset: -100 })
    },
    closeHeightSelector () {
      this.isOpen = false
      window.setTimeout(() => {
        window.scrollTo('.product-configurator', 0, { offset: -100 })
      }, 200);
    },
    jumpToProduct () {
      const element = document.getElementById('product-main')
      const top = element.offsetTop - 100;
      window.scrollTo({ top, behavior: 'smooth' })
    }
  }
}
</script>
